import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import type { UserPageBrainActivityResponse } from "@/components/user/brain/userPageBrainActivity.helpers";
import { Time } from "@/helpers/time";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
interface UseIdentityActivityOptions {
  readonly identity: string | null | undefined;
  readonly enabled?: boolean | undefined;
}
export function useIdentityActivity(t0) {
  const $ = _c(12);
  const {
    identity,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== identity) {
    const normalizedIdentity = identity?.trim() ?? "";
    t2 = normalizedIdentity.toLowerCase();
    $[0] = identity;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const canonicalIdentity = t2;
  let t3;
  let t4;
  if ($[2] !== canonicalIdentity) {
    t3 = [QueryKey.IDENTITY_ACTIVITY, canonicalIdentity];
    t4 = async () => {
      if (!canonicalIdentity) {
        throw new Error("Identity is required to fetch brain activity");
      }
      return await commonApiFetch({
        endpoint: `identities/${encodeURIComponent(canonicalIdentity)}/activity`
      });
    };
    $[2] = canonicalIdentity;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = enabled && canonicalIdentity.length > 0;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Time.minutes(15).toMillis();
    t7 = Time.hours(1).toMillis();
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = getDefaultQueryRetry();
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t9 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: t6,
      gcTime: t7,
      refetchOnWindowFocus: false,
      ...t8
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return useQuery(t9);
}